import { updates } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-10">最新快讯</h2>
        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300"></div>
          <div className="flex flex-col gap-5">
            {updates.map((item) => (
              <div key={item.id} className="relative flex items-start gap-5 pl-12">
                <span className="absolute left-0 top-1.5 w-[10px] h-[10px] rounded-full bg-primary-500 ring-4 ring-primary-100"></span>
                <span className="text-xs font-medium text-foreground-400 whitespace-nowrap mt-0.5 min-w-[80px]">
                  {item.date}
                </span>
                <div className="flex flex-col sm:flex-row sm:items-center gap-2 min-w-0">
                  <span className="inline-flex px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold whitespace-nowrap w-fit">
                    {item.tag}
                  </span>
                  <span className="text-sm text-foreground-700 leading-relaxed">{item.title}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}